import React from 'react'
import { SnackbarProvider } from 'notistack'
import store from './redux/store'
import { connect } from 'react-redux'
import { initSetting } from './redux/actions/setting'
import Theme from './Theme'
import Routing from './Routing'
import WebSocket from './components/WebSocket'
import WindowSize from './components/WindowSize'
import Sound from './components/Sound'
import Gamepad from './components/Gamepad'

const Root = ({ setting: { personal } }) => {
  React.useEffect(() => {
    store.dispatch(initSetting())
  }, [])

  return personal && (
    <Theme>
      <SnackbarProvider>
        <Routing />
        <WebSocket />
        <WindowSize />
        <Sound />
        <Gamepad />
      </SnackbarProvider>
    </Theme>
  )
}

export default connect(
  state => ({
    setting: state.setting
  })
)(Root)
